import { isEqual } from 'lodash';
import { PropEventBroker } from './PropEventBroker';
import { getCurrentTimestamp } from '../getCurrentTimestamp';
export class RestorablePropEventBroker extends PropEventBroker {
    constructor(emitter, initialValue, options) {
        super(emitter, initialValue, options);
        this._lastChangedTimestamp = 0;
        this._lastCommitTimestamp = 0;
        this._defaultValue = initialValue;
    }
    getStoredValue() {
        return this._defaultValue;
    }
    resetToDefault() {
        return this.set(this._defaultValue);
    }
    isChanged() {
        return this._lastChangedTimestamp > this._lastCommitTimestamp;
    }
    restore() {
        this.resetToDefault();
    }
    commitInner() {
        this._defaultValue = this.get();
        this._lastCommitTimestamp = getCurrentTimestamp();
    }
    commit() {
        if (this._defaultValue !== this.get()) {
            this.commitInner();
            // Hack to make the Broker raise an event
            this.emitValueChanged();
        }
    }
    set(value, options) {
        return super.set(value, options);
    }
    setValueInner(newValue, options) {
        if (!isEqual(newValue, this._defaultValue)) {
            this._lastChangedTimestamp = getCurrentTimestamp();
        }
        else {
            this._lastChangedTimestamp = this._lastCommitTimestamp;
        }
        super.setValueInner(newValue, options);
        if (options?.commit) {
            this.commitInner();
        }
    }
}
//# sourceMappingURL=RestorablePropEventBroker.js.map